import { useEffect, useState } from "react";
import api from "../config/api";
const useRestaurantDetail = (id) => {
  const [restaurant, setRestaurant] = useState(null);
  const [menu, setMenu] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      try {
        setLoading(true);

        const res = await api.get(
          `/restaurants/${id}`
        );

        setRestaurant(res.data.restaurant);
        setMenu(res.data.menu);

      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

  }, [id]);
  return { restaurant, menu, loading, error };
};

export default useRestaurantDetail;